import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import React, { FC, MutableRefObject, useEffect, useRef } from 'react';
import { TSitecoreContext } from '../../../../types/sitecore.types';
import { TCardAnimProps, TCardProps } from '../../types/cardColumnLayout.types';
import { CardModel } from './models/card.models';
import ImageCard from './imageCard';
import './styles.scss';
import IconCard from './iconCard';
import { windowService } from '../../../../utils/window.utils';
import './iconCard/styles.scss';
import './imageCard/styles.scss';

const Card: FC<TCardProps & { sitecoreContext: TSitecoreContext } & TCardAnimProps> = ({
  card,
  layout,
  textcolor,
  primarycta,
  secondarycta,
  shouldAnimate = false,
  animationDeleyInMs = null,
  cardHeadingTag,
  showInMobile,
  sitecoreContext,
  isEE,
}) => {
  const model = new CardModel(card);
  const cardRef: MutableRefObject<HTMLElement | null> = useRef(null);

  const setCardMinHeight = () => {
    if (!cardRef?.current) return;
    cardRef.current.style.minHeight = `${cardRef.current.clientHeight}px`;
  };

  const resetCardMinHeight = () => {
    if (!cardRef?.current) return;
    cardRef.current.style.minHeight = '';
  };

  useEffect(() => {
    if (!cardRef?.current) return;
    setCardMinHeight();

    let timeOutFunctionId;

    const _onResizeRefreshMinHeightCard = () => {
      if (timeOutFunctionId) clearTimeout(timeOutFunctionId);
      resetCardMinHeight();
      timeOutFunctionId = setTimeout(setCardMinHeight, 500);
    };

    windowService()?.addEventListener('resize', _onResizeRefreshMinHeightCard);

    return () => {
      windowService()?.removeEventListener('resize', _onResizeRefreshMinHeightCard);
    };
  }, [cardRef]);

  return (
    <article
      ref={cardRef}
      style={{ '--anim-delay': `${animationDeleyInMs}ms` } as React.CSSProperties}
      className={(model?.iconValue ? ' icon-card' : ' image-card') + (shouldAnimate ? ' card-column--load-animation' : '')}
    >
      {model?.iconValue ? (
        <IconCard
          model={model}
          isEE={isEE}
          cardHeadingTag={cardHeadingTag}
          textcolor={textcolor}
          primarycta={primarycta}
          secondarycta={secondarycta}
          showInMobile={showInMobile}
          sitecoreContext={sitecoreContext}
        />
      ) : (
        <ImageCard
          model={model}
          isEE={isEE}
          cardHeadingTag={cardHeadingTag}
          layout={layout}
          textcolor={textcolor}
          primarycta={primarycta}
          secondarycta={secondarycta}
        />
      )}
    </article>
  );
};

export default withSitecoreContext()(Card);
